'use client'

import { WagmiProvider, createConfig, http } from 'wagmi'
import { mainnet, polygon } from 'wagmi/chains'
import { injected, walletConnect } from 'wagmi/connectors'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'
import type { EIP1193Provider } from 'viem'

const wcProjectId = process.env.NEXT_PUBLIC_WC_PROJECT_ID ?? ''

const config = createConfig({
  chains: [mainnet, polygon],
  // ssr: true defers auto-reconnect to the client, preventing wagmi from
  // accessing browser-only storage during Next.js server-side rendering.
  ssr: true,
  connectors: [
    injected({ target: 'metaMask' }),
    injected({
      target: {
        id: 'krakenWallet',
        name: 'Kraken Wallet',
        provider: () =>
          (window as unknown as Record<string, unknown>).krakenwallet as
          | EIP1193Provider
          | undefined,
      },
    }),
    // walletConnect (Reown AppKit) accesses indexedDB on init — browser only
    ...(typeof window !== 'undefined' && wcProjectId
      ? [walletConnect({ projectId: wcProjectId, showQrModal: true })]
      : []),
  ],
  transports: {
    [mainnet.id]: http(),
    [polygon.id]: http(),
  },
})

export function WalletProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient())

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  )
}
